import axios from 'axios';

import {
  API_LOGIN_PATH,
  API_LOGOUT_PATH,
  API_FETCH_CANDIDATES_PATH,
  API_FETCH_RECRUITERS_PATH,
  API_FETCH_MATCHES_PATH,
  API_UPDATE_MATCHES_PATH,
  API_GET_USER_SESSION_PATH,
  API_CHANGE_APPROVED_STATUS_PATH,
  API_CHANGE_MATCHES_APPROVED_STATUS_PATH,
} from '../constants';

export const getUserSession = () => {
  return axios
    .get(API_GET_USER_SESSION_PATH)
    .then(response => response.data);
};

export const login = payload => {
  return axios
    .post(API_LOGIN_PATH, payload)
    .then(response => response.data);
};

export const logout = () => {
  return axios
    .get(API_LOGOUT_PATH)
    .then(response => response.data);
};


export const fetchCandidates = () => {
  return axios
    .get(API_FETCH_CANDIDATES_PATH)
    .then(response => response.data);
};

export const fetchRecruiters = () => {
  return axios
    .get(API_FETCH_RECRUITERS_PATH)
    .then(response => response.data);
};

export const fetchMatches = () => {
  return axios
    .get(API_FETCH_MATCHES_PATH)
    .then(response => response.data);
};

export const updateMatches = () => {
  return axios
    .get(API_UPDATE_MATCHES_PATH)
    .then(response => response.data);
};

export const updateMatchesWith = ({candidateIds, vacancyIds}) => {
  return axios
    .post(API_UPDATE_MATCHES_PATH, {candidateIds, vacancyIds})
    .then(response => response.data);
};

export const changeMatchesApprovedStatus = id => {
  return axios
    .get(`${API_CHANGE_MATCHES_APPROVED_STATUS_PATH}/${id}`)
    .then(response => response.data);
};

export const changeApprovedStatus = id => {
  return axios
    .get(`${API_CHANGE_APPROVED_STATUS_PATH}/${id}`)
    .then(response => response.data);
};



// WEBPACK FOOTER //
// ./src/api/index.js